import {ROUTES} from 'routes';

import PanelContainer from 'components/PanelContainer';
import {useDismissBehavior} from 'hooks/useDismissBehavior';
import {useNavigateWithParams} from 'hooks/useNavigateWithParams';

const TITLE = 'SET UP MULTI-FACTOR AUTHENTICATION';
const BODY_TEXT =
  'To take advantage of your rewards and redeem in the Caesars Rewards Marketplace, you must have Multi-Factor Authentication set up on your account.  If you choose to decline, you will be returned to the Marketplace to view items but will not be able to redeem credits.';

const OptinRequired = () => {
  const onDeclineMFA = useDismissBehavior();
  const navigate = useNavigateWithParams();

  return (
    <PanelContainer
      title={TITLE}
      bodyText={BODY_TEXT}
      primaryTitle="Proceed"
      secondaryTitle="I Decline"
      onPrimaryPress={() => navigate(ROUTES.preference)}
      onSecondaryPress={onDeclineMFA}
    />
  );
};

export default OptinRequired;
